// src/pages/SellerIntelligence/Orders/OrderFulfillment.js
//
// Order Fulfillment Dashboard. Two interaction models on one page, and the
// difference is deliberate rather than an inconsistency to smooth over.
//
// The operations board answers "what needs me now" and carries no date control
// at all. The analytical surfaces below answer "over a period". Two of them —
// late shipment and defect rate — are Amazon's own account health figures on
// Amazon's own window, so they ignore the control too, and say so.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import styles from '../SellerIntelligence.module.css';
import { WindowControl, useWindowControl } from '../components/WindowControl';
import OrderBoard from './components/OrderBoard';
import CancellationRate from './components/CancellationRate';
import CancellationAttribution from './components/CancellationAttribution';
import FulfilmentTime from './components/FulfilmentTime';
import LateShipment from './components/LateShipment';
import DefectRate from './components/DefectRate';

const OrderFulfillment = () => {
  const navigate = useNavigate();
  const control = useWindowControl();

  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button
          className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence/orders')}
        >
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Order Fulfillment Dashboard</h1></div>
          <p>
            What needs your attention right now, and where your fulfilment
            metrics come from.
          </p>
        </div>
      </div>

      <div className={styles.content}>
        <OrderBoard />

        {/* The window governs the analytical surfaces only. The board above
            answers "now" and deliberately ignores it. */}
        <WindowControl control={control} />


        <CancellationRate window={control.applied} onLoadingChange={control.track('cancellationRate')} />

        <CancellationAttribution window={control.applied} onLoadingChange={control.track('cancellationAttribution')} />

        <FulfilmentTime window={control.applied} onLoadingChange={control.track('fulfilmentTime')} />

        <LateShipment />

        <DefectRate />
      </div>
    </div>
  );
};

export default OrderFulfillment;
